import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container } from "@mui/material";
import api from "../globals/axios";
import CustomAppBar from "../components/AppBar";
import VerifactionTaskCards from "../components/VerifactionTaskCards";

export default function Claims() {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/verification/my-verification-requests/`)
      .then((result) => {
        setTasks(result.data);
      })
      .catch((err) => {
        alert("Error - " + err.response.data.non_field_errors[0]);
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid container justify="center" direction="column" mt={2}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            My Claims
          </Typography>

          {tasks.length === 0 ? (
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              No claims found. Please add new claim.
            </Typography>
          ) : (
            <VerifactionTaskCards tasks={tasks} />
          )}

          <Button onClick={() => (window.location.href = "/create-claim")}>
            Add Claim
          </Button>
        </Grid>
      </Container>
    </>
  );
}
